
const loadingComponent = () => {

    return (
        <>
            loading
        </>
    );
}

export default loadingComponent;
